import api from './api';

/**
 * Authentication Service Wrapper
 */
export const authService = {
  /**
   * Submits credentials to exchange for secure session tokens
   */
  login: async (email: string, password: string): Promise<any> => {
    const response = await api.post('/login', { email, password });
    
    if (response.data.success && response.data.data.token) {
      localStorage.setItem('school_saas_token', response.data.data.token);
      localStorage.setItem('school_saas_user', JSON.stringify(response.data.data.user));
    }
    
    return response.data;
  },

  /**
   * Registers a new teacher account
   */
  register: async (data: { first_name: string; last_name: string; email: string; password: string; role?: string; employee_id?: string }): Promise<any> => {
    const response = await api.post('/register', data);
    return response.data;
  },

  /**
   * Discards tokens and wipes local session states
   */
  logout: (): void => {
    localStorage.removeItem('school_saas_token');
    localStorage.removeItem('school_saas_user');
  },

  /**
   * Retrieves active teacher identity details
   */
  getCurrentUser: (): any | null => {
    const cached = localStorage.getItem('school_saas_user');
    return cached ? JSON.parse(cached) : null;
  },

  /**
   * Fast state check for valid active sessions
   */
  isAuthenticated: (): boolean => {
    return localStorage.getItem('school_saas_token') !== null;
  }
};
export default authService;
